module.exports = __webpack_public_path__ + "static/media/background_VAL.574cf789.jpg";